var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"row\">\n<div class=\"col-sm-12 react-settings-page\">\n<pkp-storage-admin-premium-services ng-if=\"$ctrl.activeSetting == 'premium-services'\">\n</pkp-storage-admin-premium-services>\n<pkp-storage-advanced-settings [sso-ref-id]=\"$ctrl.authenticatedUser.referenceId\" ng-if=\"$ctrl.activeSetting === 'general'\">\n</pkp-storage-advanced-settings>\n</div>\n</div>\n";
var id1="app/storage-admin/storage-settings.component.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;